/**
 * Shared skeleton styles and keyframe injection for loading placeholders.
 * Import this in any component that uses shimmer animation.
 */
import type React from 'react';

// Inject the shimmer keyframe once globally
if (typeof document !== 'undefined') {
  const styleId = 'skeleton-shimmer-keyframe';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `;
    document.head.appendChild(style);
  }
}

export const skeletonBase: React.CSSProperties = {
  borderRadius: 4,
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
};
